<template>
<div>
  <template v-if="$route.name === 'EXSBPaymentsMadeCreate'">
    <b-row>
      <b-col>
        <router-link :to="{ name: 'EXSBPaymentsMadeList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col>
                <Form
                  :handle-submit="onSendForm"
                  :values="item"/>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </template>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Create',
  components: {
    Form
  },
  data () {
    return {
      item: {
        idAgreement: null,
        idEXSBInvoice: null,
        type: 1,
        value: 0,
        description: ''
      }
    }
  },
  watch: {
    created (val) {
      if (val) this.$router.push({ name: 'EXSBPaymentsMadeList' })
    }
  },
  beforeCreate () {
    checkPagePermission('finances', 'EXSBPaymentsMadeCreate')
  },
  computed: {
    ...mapGetters({
      created: 'exsbpaymentsmade/create/created',
      isLoading: 'exsbpaymentsmade/create/isLoading'
    })
  },
  methods: {
    onSendForm () {
      this.create(this.item)
    },
    ...mapActions({
      create: 'exsbpaymentsmade/create/create'
    })
  }
}
</script>

<style scoped>

</style>
